export default function downloadGraph() {
  return {
    downloadChart(chartId = 'kpi-chart', projectName = '') {
      const chart = Chartkick.charts[chartId]?.getChartObject();
      if (!chart) return;

      const url = chart.toBase64Image();
      const link = document.createElement('a');
      link.href = url;
      link.download = `${projectName}_graph_${new Date().toISOString().split('T')[0]}.png`;
      link.click();
    }
  };
}
